import { useApp } from "../context/AppContext";

export default function OrderConfirmationPage() {
  const { activeProduct: orderData, navigate } = useApp();

  // orderData = { orderNumber: "PC-00001" } passed from CheckoutPage
  const orderNumber = orderData?.orderNumber ?? "—";

  return (
    <div className="page-wrap fade-up">
      <div className="confirmation-wrap">

        {/* ── Success icon ── */}
        <div className="confirmation-icon-ring">
          <span className="confirmation-icon">✅</span>
        </div>

        {/* ── Heading ── */}
        <h1 className="confirmation-title">Order Placed!</h1>
        <p className="confirmation-subtitle">
          Thank you for your order. We're getting everything ready for your pickup.
        </p>

        {/* ── Order number chip ── */}
        <div className="confirmation-order-chip">
          <span className="confirmation-order-label">Your Order Number</span>
          <span className="confirmation-order-number">{orderNumber}</span>
        </div>

        {/* ── Info cards ── */}
        <div className="confirmation-cards">

          <div className="confirmation-card">
            <div className="confirmation-card-icon">📧</div>
            <div>
              <div className="confirmation-card-title">Check Your Email</div>
              <div className="confirmation-card-body">
                A confirmation email with your full order details and pickup time has
                been sent to your inbox. Check your <b>spam</b> or <b>junk</b> folder if you don't see it
                within a few minutes.
              </div>
            </div>
          </div>

          <div className="confirmation-card">
            <div className="confirmation-card-icon">🪪</div>
            <div>
              <div className="confirmation-card-title">Bring Valid Photo ID</div>
              <div className="confirmation-card-body">
                You must present a government-issued photo ID matching the name on
                this order at the time of pickup. We reserve the right to refuse
                service at our discretion.
              </div>
            </div>
          </div>

          <div className="confirmation-card">
            <div className="confirmation-card-icon">💵</div>
            <div>
              <div className="confirmation-card-title">Payment at Pickup</div>
              <div className="confirmation-card-body">
                Payment is collected in-store when you pick up your order.
                We accept cash and most major cards.
              </div>
            </div>
          </div>

          <div className="confirmation-card">
            <div className="confirmation-card-icon">📍</div>
            <div>
              <div className="confirmation-card-title">Pickup Location</div>
              <div className="confirmation-card-body">
                <strong>Private Convenience</strong><br />
              London, Ontario<br />
                <a href="tel:###-###-####" className="confirmation-link">###-###-####</a>
              </div>
            </div>
          </div>

        </div>

        {/* ── Actions ── */}
        <div className="confirmation-actions">
          <button
            className="confirmation-btn-primary"
            onClick={() => navigate("home")}
          >
            Back to Home
          </button>
          <button
            className="confirmation-btn-secondary"
            onClick={() => navigate("products", "other")}
          >
            Continue Shopping →
          </button>
        </div>

      </div>
    </div>
  );
}
